import Components from "slotworks/components/components";
import GameState from "slotworks/model/game-state";
import { Services } from "slotworks/services/services";
import State from "slotworks/state-machine/states/state";

export default class Recover extends State {
    public onEnter() {
        Services.transaction.setBalance(GameState.getCurrentGame().balance);

        Components.alert.info("rec.spi").then(() => this.complete());
    }
}
